export default {
  // 启动页面
  start: {
    use: 'Get Started',
    tip: 'Click "Get Started" to begin your smart experience!',
    connecting: 'Connecting...',
    waitingPairing: 'Waiting for pairing',
    pairingHint: 'Please turn on your headset and wait for pairing',
    waitingUSB: 'Waiting for USB connection',
    usbHint: 'Please ensure the USB cable is properly connected',
    retry: 'Retry',
    errorDefault: 'Connection failed, please try again',
    deviceNotFound: 'Device not found, please check connection',
    permissionDenied: 'Device permission denied',
  },

  // 耳返
  sidetone: {
    label: 'Sidetone',
    volume: 'Volume',
    enabled: 'Enabled',
    disabled: 'Disabled',
  },

  // 音频混合
  audio: {
    mix: 'Mix',
    split: 'Split',
    adaptive: 'Adaptive',
    balance: 'Audio Balance',
    dongle: 'Dongle',
    bluetooth: 'Bluetooth',
    usb: 'USB',
  },

  // 通话桥接
  callBridge: {
    label: 'Call Bridge',
    enabled: 'Enabled',
    disabled: 'Disabled',
    consentTitle: 'Call Bridge Feature Notice',
    consentMessage: 'Call Bridge allows seamless switching between game and call audio. Please read the following before enabling:',
    point1: 'This feature mixes game audio and call audio',
    point2: 'May affect game audio quality',
    point3: 'Recommended to enable only when needed',
    noticeTitle: 'Important Notice',
    noticeContent: 'First-time use requires audio device permission configuration. Please follow system prompts.',
    agree: 'I Understand and Agree',
  },

  // 蓝牙分享
  btShare: {
    label: 'Bluetooth Share',
    enabled: 'Enabled',
    disabled: 'Disabled',
    consentTitle: 'Bluetooth Audio Share',
    consentMessage: 'Bluetooth audio sharing allows multiple devices to listen simultaneously. Please note:',
    point1: 'Share audio to nearby Bluetooth devices',
    point2: 'May slightly increase audio latency',
    point3: 'Bluetooth connection must be active',
    noticeTitle: 'Usage Tips',
    noticeContent: 'Ensure the receiving device has Bluetooth enabled and is in pairing mode.',
    agree: 'Got it, Enable',
  },

  // 固件升级
  upgrade: {
    title: 'Firmware Upgrade',
    currentVersion: 'Current Version',
    dongleTab: 'Dongle',
    headsetTab: 'Headset',
    bluetoothTab: 'Bluetooth',
    dongleUpgrade: 'Dongle Firmware Upgrade',
    headsetUpgrade: 'Headset Firmware Upgrade',
    bluetoothUpgrade: 'Bluetooth Firmware Upgrade',
    dongleDesc: 'Upgrade Dongle firmware for better connection stability',
    headsetDesc: 'Upgrade headset firmware for better sound quality and features',
    bluetoothDesc: 'Upgrade Bluetooth module firmware',
    step1: 'Select Firmware File',
    step2: 'Verify File',
    step3: 'Upload & Upgrade',
    step4: 'Complete',
    selectFile: 'Please select firmware file (.bin, .hex, .fw)',
    verifyFile: 'Verify firmware file information',
    upgrading: 'Upgrading, please do not disconnect...',
    waiting: 'Waiting to complete',
    success: 'Upgrade successful!',
    startUpgrade: 'Start Upgrade',
    complete: 'Complete',
    uploading: 'Uploading',
    verifying: 'Verifying',
    warning: '⚠️ Important Notice',
    warningPoint1: 'Do not disconnect device during upgrade',
    warningPoint2: 'Upgrade may take 3-5 minutes, please be patient',
    warningPoint3: 'Failed upgrade may cause device malfunction, proceed with caution',
    headsetNotice: 'Headset upgrade feature coming soon',
    bluetoothNotice: 'Bluetooth upgrade feature coming soon',
  },
  // Common
  common: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
    loading: 'Loading...',
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    info: 'Info',
  },

  // Navigation
  nav: {
    home: 'Home',
    eq: 'EQ Settings',
    rgb: 'RGB Lighting',
    noise: 'ENC',
    voice: 'Voice Effects',
    chiji: 'Gaming Mode',
    ai: 'AI Assistant',
    upgrade: 'Firmware Upgrade',
    user: 'User Center',
    settings: 'Settings',
    logout: 'Logout',
  },

  // RGB
  rgb: {
    title: 'RGB Lighting Settings',
    on: 'ON',
    off: 'OFF',
    selectMode: 'Select Lighting Mode',
    brightness: 'Brightness',
    connectDevice: 'Please connect device to control RGB lighting',
    modes: {
      breathing: 'Breathing',
      gradient: 'Gradient',
      chase: 'Chase',
      red: 'Red',
      blue: 'Blue',
      green: 'Green',
      purple: 'Purple',
      yellow: 'Yellow',
      cyan: 'Cyan',
      white: 'White',
    },
  },

  // Home Page
  home: {
    start: 'Get Started',
    connectDevice: 'Connect Device',
    deviceNotFound: 'Device not detected, please insert and try again',
    welcome: 'Welcome to Aiiifly',
    slogan: 'See It, Hear It, Touch It',
    startHint: 'Click "Get Started" to begin your intelligent experience!',
    icp: 'ICP 2025456694',
    noDeviceConnector: 'No receiver detected. Please plug it in and try again.',
    usbIdentifyError: 'Device identification failed. Refresh the page or reconnect the device and try again.',
    waitingPairing: 'Receiver detected. Turn on the device to complete pairing.',
    connectionError: 'Connection failed. Please try again.',
    waitingUsbDevice: 'Waiting for USB device...',
    waitingDevice: 'Waiting for device...',
  },

  // Device
  device: {
    connected: 'Connected',
    disconnected: 'Disconnected',
    connecting: 'Connecting...',
    battery: 'Battery',
    batteryLow: 'Low Battery',
    charging: 'Charging',
    headphone: 'Headphone',
    microphone: 'Microphone',
    usbMode: 'USB Wired Mode',
    wirelessMode: '2.4G Wireless Mode',
    unknown: 'Unknown Device',
    bluetooth: 'Bluetooth Version',
  },

  // EQ
  eq: {
    title: 'EQ Settings',
    game: 'Game Mode',
    music: 'Music Mode',
    movie: 'Movie Mode',
    gameShort: 'Game',
    musicShort: 'Music',
    movieShort: 'Movie',
    enabled: 'EQ On',
    disabled: 'EQ Off',
    custom: 'Custom',
    addCustom: 'Add Custom',
    deleteConfirm: 'Are you sure you want to delete this preset?',
    reset: 'Reset',
    pin: 'Pin',
    saveAs: 'Save As',
    copy: 'copy',
    saved: 'Preset saved',
    pinned: 'Preset pinned',
    resetDone: 'Preset reset',
    customLimit: 'You can save up to 20 custom presets',
    nameExists: 'A preset with this name already exists',
    rename: 'Rename Preset',
    gain: 'Gain',
    frequency: 'Frequency',
  },

  // Noise Reduction
  noise: {
    title: 'AI Noise Reduction',
    aiNoise: 'AI Noise Reduction',
    aiNoiseHeadphone: 'AI Noise Reduction',
    micNoise: 'Mic Noise Reduction',
    level: 'Reduction Level',
    levelLow: 'Low',
    levelMedium: 'Medium',
    levelHigh: 'High',
    enc: 'AI ENC',
    encDesc: 'Intelligently identifies ambient noise to improve call clarity',
    aiNoiseDesc: 'Recommended during calls or recording to effectively reduce ambient noise',
  },

  // Voice Effects
  voice: {
    title: 'Voice Effects',
    enabled: 'Enable Voice Change',
    boy: 'Boy',
    girl: 'Girl',
    child: 'Child',
    robot: 'Robot',
    monster: 'Monster',
    normal: 'Normal',
    preview: 'Effect Preview',
    previewHint: 'Turn on to preview voice effects in real-time',
  },

  // Firmware
  firmware: {
    title: 'Firmware Upgrade',
    currentVersion: 'Current Version',
    latestVersion: 'Latest Version',
    checkUpdate: 'Check for Updates',
    startUpgrade: 'Start Upgrade',
    selectTarget: 'Select Upgrade Target',
    updating: 'Updating...',
    updateSuccess: 'Update Successful',
    updateFailed: 'Update Failed',
    releaseNotes: 'Release Notes',
    deviceReady: 'Device Ready',
    deviceLowPower: 'Low Battery',
    deviceBusy: 'Device Busy',
    historyVersions: 'History Versions',
    selectLocalFile: 'Select Local Firmware',
    manualPick: 'Select Device Manually',
    version: 'Version',
    updateDate: 'Updated',
    management: 'Firmware Management',
    device: 'Device',
    description: 'Description',
    action: 'Action',
    upgradeToLatest: 'Upgrade to Latest Version',
    rollbackTip: 'To roll back, view ',
    upgradeToThisVersion: 'Upgrade to this version',
    confirmUpgradeTitle: 'Upgrade to {version}?',
    confirmUpgradeDesc: 'After confirmation, the upgrade will run to completion and cannot be interrupted. Keep power and connection stable.',
    preparingUpgrade: 'Preparing upgrade...',
    preparing: 'Preparing...',
    detectingDevice: 'Detecting device...',
    reconnectingDevice: 'Reconnecting device...',
    downloadingFirmware: 'Downloading firmware...',
    sendingEnterUpgrade: 'Sending enter-upgrade command...',
    waitingUpgradeDevice: 'Command sent. Waiting for upgrade-mode device...',
    transferringFirmware: 'Transferring firmware data...',
    upgradingTitle: 'Upgrading [{device}]. Do not disconnect.',
    upgradeCompleteTitle: 'Upgrade complete [{device}]',
    upgradeFailedTitle: 'Upgrade failed [{device}]',
    upgradeComplete: 'Upgrade complete!',
    upgradeFailed: 'Upgrade failed',
    upgradeWarning: 'Upgrading. Please do not close this page or disconnect.',
    failedChoosePrefix: 'Upgrade failed, you can choose another ',
    historyVersion: 'history version',
    deviceNotFoundPlease: 'Device not found. Please ',
    selectManually: 'select manually',
    noVersions: 'No versions',
    noDeviceSelected: 'No device selected',
    unknownDevice: 'Unknown',
    deviceNotFound: 'Device not found',
    deviceInfo: 'Device: {name} (VID:0x{vid} PID:0x{pid})',
    failedSelectHistory: 'Upgrade failed. Select a history version to continue.',
    versionBeforeUpgrade: 'Version before upgrade',
    upgradeSuccessToast: 'Upgrade successful, experience updated!',
    connectionTypeUsb: 'USB wired',
    connectionTypeDongle: '2.4G wireless dongle',
    connectionTypeUnknown: 'unknown connection type',
    connectionTypeMismatch: 'The current connection type does not meet the upgrade requirement for [{device}]. Please switch to {required} and try again.',
    connectionTypeMismatchStatus: 'Current connection type is {actual}, but upgrading [{device}] requires {required}.',
    connectionTypeUnknownStatus: 'Unable to detect the current connection type. Please reconnect the correct device and try again.',
    descriptions: {
      earphone: {
        latest: 'Optimized audio EQ for richer bass and clearer treble.',
        V1_1_2: 'Optimized audio EQ.',
        V1_1_1: 'Fixed static noise.',
      },
      earphoneBluetooth: {
        latest: 'Enhanced Bluetooth connection stability.',
        V1_1_2: 'Enhanced Bluetooth stability.',
      },
      earphoneNoiseCancel: {
        latest: 'Upgraded wind-noise reduction algorithm.',
        V1_1_2: 'Advanced noise cancellation.',
      },
      dongle: {
        latest: 'Resolved USB 3.0 compatibility issues.',
        V1_1_2: 'Fixed stability issues.',
      },
    },
    tabs: {
      earphone: 'Earphone',
      earphoneBluetooth: 'Earphone Bluetooth',
      earphoneNoiseCancel: 'Noise Cancel',
      dongle: 'Dongle',
    },
  },

  // User Center
  user: {
    profile: 'Profile',
    accountSettings: 'Account Settings',
    passwordSettings: 'Password Settings',
    // Profile page
    nickname: 'Username',
    inputNickname: 'Enter',
    changeAvatar: 'Change Avatar',
    saveChanges: 'Save Changes',
    avatarEditorCancel: 'Cancel',
    avatarEditorSave: 'Save',
    // Account settings
    linkAccount: 'Link Account',
    linkPhone: 'Link Phone Number',
    inputPhone: 'Enter New',
    phoneNext: 'Next',
    phoneChange: 'Change',
    linkEmail: 'Link Email',
    inputEmail: 'Enter',
    emailNext: 'Next',
    emailChange: 'Change',
    linkThirdParty: 'Link Third-Party Account',
    linkThirdPartyDesc: 'Link a third-party account to log in to Aiiifly easily and sync your content to the platforms below to share with more friends.',
    googleLink: 'Link',
    wechatLink: 'Link',
    verificationCode: 'Verification Code',
    inputVerCode: 'Enter verification code',
    getCode: 'Get Code',
    sendCode: 'Send Code',
    resend: 'Resend in {sec}s',
    verifyNext: 'Next',
    phoneConfirm: 'Confirm Phone Number',
    emailConfirm: 'Confirm Link',
    deleteAccount: 'Delete Account',
    deleteAccountDesc: 'Deleting your account will permanently erase all data and cannot be undone. Please proceed with caution.',
    deleteAccountBtn: 'Delete Account',
    deleteDialogTitle: 'Are you sure you want to deactivate your account?',
    deleteDialogDesc: 'All data associated with this account will be permanently deleted and cannot be recovered. Please proceed with caution.',
    deleteDialogCancel: 'Cancel',
    deleteDialogConfirm: 'Confirm Account Deletion',
    // Password settings
    pwdAccount: 'Account',
    pwdEnterAccount: 'Enter phone or email',
    pwdNext: 'Next',
    pwdVerifyCode: 'Verification Code',
    pwdInputVerCode: 'Enter…',
    pwdGetCode: 'Get Code',
    pwdSendCode: 'Send Code',
    pwdVerifyNext: 'Next',
    pwdNewPassword: 'New Password',
    pwdInputNew: 'Enter',
    pwdConfirmPassword: 'Confirm New Password',
    pwdInputConfirm: 'Enter',
    pwdConfirmBtn: 'Change Password',
    pwdThirdPartyWarning: 'You are logged in via a third-party account. Please bind a phone number or email in Account Settings before setting a password.',
    // Tips
    tipUsernameEmpty: 'Username cannot be empty.',
    tipUsernameSuccess: 'Username updated successfully.',
    tipAvatarSuccess: 'Avatar updated successfully.',
    tipAvatarFail: 'Avatar processing failed.',
    tipSelectImage: 'Please select an image file.',
    tipEnterPhone: 'Please enter phone number',
    tipInvalidPhone: 'Please enter a valid phone number',
    tipEnterEmail: 'Please enter email',
    tipInvalidEmail: 'Please enter a valid email',
    tipEnterCode: 'Please enter 6-digit verification code',
    tipCodeSent: 'Verification code sent',
    tipPhoneBound: 'Phone bound successfully',
    tipEmailBound: 'Email bound successfully',
    tipBindFailed: 'Binding failed, please try again',
    tipOnlyAuth: 'Current account is the only authentication method and cannot be changed',
    tipVerifyPassed: 'Verification passed, please bind new account',
    tipGoogleBound: 'Google account bound successfully',
    tipWechatBound: 'WeChat account bound successfully',
    tipAllowPopup: 'Please allow popups to complete binding',
    tipDeleteSuccess: 'Account deleted successfully',
    tipEnterPhoneEmail: 'Please enter phone number or email',
    tipInvalidPhoneEmail: 'Please enter a valid phone number or email',
    tipAccountNotLinked: 'This account is not linked. You can only change the password for your current login account.',
    tipPwdFormat: 'Password must be 8-16 characters and contain letters and numbers',
    tipPwdMismatch: 'Passwords do not match.',
    tipPwdSuccess: 'Password changed successfully.',
    tipCodeSentSuccess: 'Verification code sent',
    tipEnter6Code: 'Please enter 6-digit verification code',
    // misc
    email: 'Email',
    phone: 'Phone',
    avatar: 'Avatar',
    password: 'Password',
    changePassword: 'Change Password',
    saveSuccess: 'Saved Successfully',
  },

  // Auth
  auth: {
    login: 'Login',
    register: 'Register',
    forgotPassword: 'Forgot Password',
    email: 'Email',
    phone: 'Phone Number',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    verificationCode: 'Verification Code',
    getCode: 'Get Code',
    loginSuccess: 'Login Successful',
    registerSuccess: 'Registration Successful',
    passwordMismatch: 'Passwords do not match',
    username: 'Username',
    rememberMe: 'Remember Me',
    noAccount: "Don't have an account?",
    registerNow: 'Register Now',
    hasAccount: 'Already have an account?',
    loginNow: 'Login Now',
    agreeTerms: 'I agree to the',
    termsOfService: 'Terms of Service',
    and: 'and',
    privacyPolicy: 'Privacy Policy',
    authType: 'Auth Type',
    // Login page
    headerTitle: 'Welcome to your account',
    googleLogin: 'Google',
    wechatLogin: 'WeChat',
    middleTitle: 'Phone/Email Sign in',
    phoneOrEmail: 'Phone Number/Email',
    inputPhoneOrEmail: 'Please enter your phone number or email',
    inputPassword: 'Please enter your password',
    passwordLoginBtn: 'Password Login',
    codeLoginBtn: 'Verification Code Login',
    passwordTips: 'Please confirm that you have set a password.',
    sendCodeBtn: 'Send Verification Code',
    loginBtn: 'Login',
    securityText: 'By logging in, you agree to the website',
    userAgreement: 'User Agreement',
    privacyAgreement: 'Privacy Agreement',
    // Verify page
    checkPhone: 'Check SMS to Your Phone',
    checkEmail: 'Check your email',
    verifyInstruction: 'Please enter the 6-digit verification code we sent to',
    verifySuffix: '.',
    verifyBtn: 'Verify',
    resendCode: 'Resend Code',
    resendCodeCountdown: '{sec} s Resend Code',
    // Tips
    tipEnterAccount: 'Please enter your phone number or email',
    tipInvalidAccount: 'Please enter a valid phone number or email',
    tipPasswordFormat: 'Password must be 8-16 characters and contain letters and numbers',
    tipWaitResend: 'Please wait {sec} seconds before resending',
    tipCodeFailed: 'Failed to get verification code',
    tipEnterCode: 'Please enter a 6-digit verification code',
    tipVerifyFailed: 'Verification code error',
    tipLoginFailed: 'Login failed',
    tipResendFailed: 'Failed to resend',
    tipThirdPartyFailed: 'Failed to get login URL',
    loading: 'Please wait...',
    verifying: 'Verifying...',
  },

  // Chiji (Gaming Mode)
  chiji: {
    title: 'Gaming Mode',
    footsteps: 'Footsteps',
    gunfire: 'Gunshots',
    enabled: 'Enable Gaming Mode',
    presets: 'Presets',
    addPreset: 'Add Preset',
    deletePreset: 'Delete Preset',
    deleteConfirm: 'Are you sure you want to delete preset "{name}"?',
    presetNamePlaceholder: 'Enter preset name',
    gunSound: 'Gun Sound Enhancement',
    footstep: 'Footstep Enhancement',
    gunHint: 'Enhance low-frequency gun sounds for better shooting feedback',
    footstepHint: 'Enhance high-frequency footsteps for better positioning',
    reset: 'Reset',
    description: 'Gaming mode enhances gun sounds and footsteps through EQ adjustment. Low frequencies (20-1000Hz) optimize gun sounds, high frequencies (2000-16000Hz) optimize footsteps.',
  },

  // AI Assistant
  aiAssistant: {
    title: 'AI Assistant',
    enabled: 'Enable Voice Control',
    disabled: 'Voice Control Disabled',
    tapToSpeak: 'Tap microphone to start voice control',
    listening: 'Listening...',
    quickCommands: 'Quick Commands',
    showHistory: 'View History',
    hideHistory: 'Hide History',
    noHistory: 'No voice records yet',
    clearHistory: 'Clear History',
    categoryEq: 'EQ Mode',
    categoryChiji: 'Gaming Mode',
    categoryVoice: 'Voice Effects',
    categoryDevice: 'Device',
    categorySystem: 'System',
    helpTitle: 'Usage Tips:',
    help1: 'Tap the microphone button and speak commands',
    help2: 'Supported: "Switch to game mode", "Enable gaming", "Mute", etc.',
    help3: 'Or tap quick commands below to execute directly',
    browserWarning: 'Your browser does not support speech recognition. Please use Chrome or Edge.',
    commandSuccess: 'Command executed successfully',
    commandFailed: 'Command execution failed',
  },

  // Header
  header: {
    battery: 'Battery',
    usbMode: 'USB',
    wirelessMode: '2.4G',
    language: 'Language',
    hotkey: 'Hotkeys',
    theme: {
      dark: 'Dark',
      light: 'Light',
      system: 'System',
    },
    userCenter: 'User Center',
    firmwareUpgrade: 'Firmware Upgrade',
    preferences: 'Preferences',
    about: 'About',
    aboutUs: 'About Us',
  },

  hotkey: {
    dialogTitle: 'Hotkey Settings',
    notSet: 'Not Set',
    conflict: 'Hotkey conflict: already used by',
    conflictUsed: 'Used',
    switched: 'Switched',
    powerToggle: 'Power Toggle',
    eqToggle: 'EQ Settings',
    rgbToggle: 'RGB Toggle',
    aiToggle: 'AI ENC',
    balenceToggle: 'Voice Balance',
    Positioning: 'Positioning',
    tip: 'Click input box and press keys',
    reset: 'Reset',
    occupied: 'Hotkey is occupied',
  },

  // Footer
  footer: {
    eq: 'EQ',
    rgb: 'RGB',
    voice: 'Voice',
    mute: 'Mute',
    micMute: 'Mic Mute',
    kangganrao: 'Anti-Interference',
    chiji: 'Gaming Mode',
    ai: 'AI Assistant',
    level: 'Level',
    audioMix: 'Audio Mix',
    audioSplit: 'Audio Split',
  },

  // Main (bottom menu)
  main: {
    chickenDinner: 'Positioning',
  },

  // Main RGB (bottom menu RGB modes)
  mainrgb: {
    breathing: 'Purple Rhythm',
    gradient: 'Cyan Rhythm',
    marquee: 'Blue Rhythm',
    mic_gradient: 'Spectrum',
    mic_breathing: 'Breathing',
    red: 'Red',
    blue: 'Blue',
    green: 'Green',
    purple: 'Purple',
    yellow: 'Yellow',
    cyan: 'Cyan',
    white: 'White',
  },
} as const
